module.exports = __webpack_public_path__ + "static/media/st johns2.3f1c438d.png";